

import Datepicker from "./Datapicker"; // Assuming the correct file name is "Datepicker"
import AddTable from "./AddTable";
import Header from "./Header"
import { useState } from 'react';


function Home() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFromDate, setSelectedFromDate] = useState('');
  const [selectedToDate, setSelectedToDate] = useState('');
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [changedData, setChangedData] = useState([]);

 
  // Callback to handle date selection in Datepicker
  const handleDateSelect = (fromDate, toDate,filters) => {
    setSelectedFromDate(fromDate);
    setSelectedToDate(toDate);
    setSelectedFilters(filters);
  };

  const handleFilterChange = (filters) => {
    setSelectedFilters(filters);
  };

  const handleChangeData = (data) => {
    setChangedData(data);
  };



  return (
    <div style={{ position: "relative" }}>
      <Header />
      <Datepicker onSearch={setSearchQuery} onDateSelect={handleDateSelect} handleFilterChange={handleFilterChange} changedData={changedData}/>
      <AddTable searchQuery={searchQuery} selectedFromDate={selectedFromDate} selectedToDate={selectedToDate} selectedFilters={selectedFilters} onChangeData={handleChangeData}/>
    </div>
  );
}

export default Home;

